export const apiMap = {
    'commonUrl': 'http://132.232.0.172:9501/',
    'uploadUrl': 'http://148.70.221.198:9901/',
    'register': {
        'url': 'api/user/register', //注册
        'method': 'POST'
    },
    'setPassword': {
        'url': 'api/user/set/password', //注册时设置密码
        'method': 'POST'
    },
    'login': {
        'url': 'api/user/login', //登录
        'method': 'POST'
    },
    'checkCode': {
        'url': 'api/user/check/code', //检查验证码
        'method': 'POST'
    },
    'getHandNumber': {
        'url': 'api/user/handnum', //修改密码时 获取传联号
        'method': 'POST'
    },
    'changePassword': {
        'url': 'api/user/forgot/password', //修改密码
        'method': 'POST'
    },
    'friendsList': {
        'url': 'api/user/friends/info', //好友列表 
        'method': 'POST'
    },
    'userProfile': {
        'url': 'api/user/profile', //用户资料
        'method': 'POST'
    },
    'logout': {
        'url': 'api/user/logout', //退出登录
        'method': 'POST'
    },
    'companyInfo': {
        'url': 'api/contact/us', //联系我们
        'method': 'GET'
    },
    'applyCopy': {
        'url': 'api/user/family/application', //申请复制家谱
        'method': 'POST'
    },
    'applyList': {
        'url': 'api/user/apply/relation', //获取传连申请列表
        'method': 'GET'
    },
    'applyHandlian': {
        'url': 'api/user/apply/relation', //提交传连申请
        'method': 'POST'
    },
    'respondRelation': {
        'url': 'api/user/handle/relation', //回应传连申请
        'method': 'POST'
    },
    'createRelation': {
        'url': 'api/user/create/relation', //同意传连申请
        'method': 'POST'
    },
    'imRelation': {
        'url': 'api/im/friend/relation', //更新好友关系链
        'method': 'POST'
    },
    'communityNews': {
        'url': 'api/community/news', //社区通知列表
        'method': 'POST'
    },
    'getSearchRecords': {
        'url': 'api/user/search/keywords', //获取搜索记录
        'method': 'GET'
    },
    'removeSearchRecord': {
        'url': 'api/user/delete/keywords', //删除搜索记录
        'method': 'POST'
    },
    'hotFeed': {
        'url': 'api/community/hot', //社区热点列表
        'method': 'POST'
    },
    'recommendFeed': {
        'url': 'api/community/recommend', //社区推荐列表
        'method': 'POST'
    },
    'clanFeed': {
        'url': "api/family/community", //族谱动态
        'method': "POST"
    },
    'feedDetail': {
        'url': 'api/community/detail', //动态详情
        'method': 'GET'
    },
    'shopDetail': {
        'url': "api/voucher/shop", //店铺详情[shopId]
        'method': "GET"
    },
    'shopGoods': {
        'url': "api/voucher/goods", //店铺商品
        'method': "GET"
    },
    'advertiseList': {
        'url': 'api/community/ads', //广告列表
        'method': 'POST'
    },
    'advertiseDetail': {
        'url': 'api/community/ads/detail', //广告详情 
        'method': 'GET'
    },
    'getProfile': {
        'url': 'api/user/profile', //用户资料
        'method': 'POST'
    },
    'setRemark': {
        'url': 'api/user/friends/mark', //设置好友备注姓名
        'method': 'POST'
    },
    'commentsList': {
        'url': 'api/community/comments', //动态评论列表
        'method': 'POST'
    },
    'publishComment': {
        'url': 'api/community/comment', //发布评论
        'method': 'POST'
    },
    'praiseFeed': {
        'url': 'api/community/praise', //赞或踩某条动态
        'method': 'POST'
    },
    'praiseComment': {
        'url': 'api/community/praise/comment', //赞或踩某条评论
        'method': 'POST'
    },
    'replyComment': {
        'url': 'api/community/reply/comment', //回复某条评论
        'method': 'POST'
    },
    'replyList': {
        'url': 'api/community/replies', //某条评论的回复列表
        'method': 'POST'
    },
    'removeComment': {
        'url': 'api/community/remove/comments', //移除某条评论或回复
        'method': 'POST'
    },
    'switchFollow': {
        'url': 'api/user/subscribe', //[添加/解除]关注某个用户
        'method': 'POST'
    },
    'reportReasons': {
        'url': 'api/community/report/reasons', //举报原因列表
        'method': 'GET'
    },
    'reportFeed': {
        'url': 'api/community/report', //举报某条动态
        'method': 'POST'
    },
    'submitSuggest': {
        'url': 'api/agreement', //提意见
        'method': 'POST'
    },
    'articleTag': {
        'url': 'api/article/tags', //文章标签
        'method': 'GET'
    },
    'uploadArticle': {
        'url': 'api/article', //上传文章
        'method': 'POST'
    },
    'uploadAlbum': {
        'url': 'api/photo', //上传相册
        'method': 'POST'
    },
    'uploadAudio': {
        'url': 'api/music', //上传视频
        'method': 'POST'
    },
    'uploadVideo': {
        'url': 'api/video', //上传视频
        'method': 'POST'
    },
    'articleShare': {
        'url': 'api/article/share', //文章分享
        'method': 'POST'
    },
    'albumShare': {
        'url': 'api/photo/share', //相册分享
        'method': 'POST'
    },
    'musicShare': {
        'url': 'api/music/share', //音频分享
        'method': 'POST'
    },
    'videoShare': {
        'url': 'api/video/share', //视频分享
        'method': 'POST'
    },
    'friendFeed': {
        'url': 'api/community/friends', //小区动态列表[某个好友的动态]
        'method': 'POST'
    },
    'storageConfig': {
        'url': 'api/system/setting', //存储空间配置参数
        'method': 'GET'
    },
    'userPermission': {
        'url': 'api/user/permissions', //用户权限列表
        'method': 'POST'
    },
    'userUpgrade': {
        'url': 'api/user/upgrade', //用户升级
        'method': 'POST'
    },
    'editProfile': {
        'url': 'api/user/profile/edit', //修改资料
        'method': 'POST'
    },
    'verifyCode': {
        'url': 'api/verify/code', //核对验证码
        'method': 'POST'
    },
    'changeMobile': {
        'url': 'api/user/change/mobile', //更换手机号
        'method': 'POST'
    },
    'setNewPassword': {
        'url': 'api/user/set/new/password', //设置新密码
        'method': 'POST'
    },
    'familyIntro': {
        'url': 'api/user/father/intro', //获取家训
        'method': 'GET'
    },
    'addIntro': {
        'url': 'api/user/intro', //添加家训
        'method': 'POST'
    },
    'fatherTree': {
        'url': 'api/user/father/tree', //父系家谱
        'method': 'GET'
    },
    'motherTree': {
        'url': 'api/user/mother/tree', //母系家谱
        'method': 'GET'
    },
    'deathProfile': {
        'url': 'api/death/profile', //死人资料
        'method': 'POST'
    },
    'addDeathNode': {
        'url': 'api/user/death', //手动传连
        'method': 'POST'
    },
    'agreeRelation': {
        'url': 'api/user/create/relation', //同意传联
        'method': 'POST'
    },
    'operateDeathNode': {
        'url': 'api/user/death', //添加死亡节点 & 更新死亡节点资料
        'method': 'POST'
    },
    'removeNode': {
        'url': 'api/user/remove/tree/node', //删除无后代临时节点
        'method': 'POST'
    },
    'unbindRelation': {
        'url': 'api/user/unbind/relation', //解除传连
        'method': 'POST'
    },
    'updateNode': {
        'url': 'api/user/update/tree/node', //更新临时节点
        'method': 'POST'
    },
    'getProduct': {
        'url': 'api/user/tree/node/model', //获取亲人作品
        'method': 'GET'
    },
    'addProductForNode': {
        'url': 'api/user/tree/node/model', //给死亡节点添加作品
        'method': 'POST'
    },
    'businessList': {
        'url': 'api/user/business', //获取业务列表
        'method': 'GET'
    },
    'addBusiness': {
        'url': 'api/user/business', //添加业务 
        'method': 'POST'
    },
    'articleList': {
        'url': 'api/article', //文章列表 
        'method': 'GET'
    },
    'removeArticle': {
        'url': 'api/remove/article', //删除文章
        'method': 'POST'
    },
    'removeAlbum': {
        'url': 'api/remove/photo', //删除相册
        'method': 'POST'
    },
    'removeAudio': {
        'url': 'api/remove/music', //删除音频
        'method': 'POST'
    },
    'removeVideo': {
        'url': 'api/remove/video', //删除视频
        'method': 'POST'
    },
    'hiddenProduction': {
        'url': 'api/user/hidden/content', //隐藏作品操作
        'method': 'POST'
    },
    'updateArticle': {
        'url': 'api/update/article', //编辑文章
        'method': 'POST'
    },
    'updateAlbum': {
        'url': 'api/update/photo', //编辑相册
        'method': 'POST'
    },
    'updateAudio': {
        'url': 'api/update/music', //编辑音频
        'method': 'POST'
    },
    'updateVideo': {
        'url': 'api/update/video', //编辑视频 
        'method': 'POST'
    },
    'albumList': {
        'url': 'api/photo', //相册列表 
        'method': 'GET'
    },
    'audioList': {
        'url': 'api/music', //音频列表 
        'method': 'GET'
    },
    'videoList': {
        'url': 'api/video', //视频列表 
        'method': 'GET'
    },
    'saveArticle': {
        'url': 'api/article/storage', //保存文章
        'method': 'POST'
    },
    'saveAlbum': {
        'url': 'api/photo/storage', //保存相册
        'method': 'POST'
    },
    'saveMusic': {
        'url': 'api/music/storage', //保存音频
        'method': 'POST'
    },
    'saveVideo': {
        'url': 'api/video/storage', //保存视频 
        'method': 'POST'
    },
    'followList': {
        'url': 'api/user/followers', //关注 & 粉丝列表
        'method': 'POST'
    },
    'appLink': {
        'url': 'api/app/uptodate', //app链接
        'method': 'GET'
    },
    'loginQrCode': {
        'url': 'api/user/login/qrcode', //登录二维码链接
        'method': 'GET'
    },
    'qrCodeLogin': {
        'url': 'api/user/login/qrcode', //二维码登录
        'method': 'POST'
    },
    'cityData': {
        'url': 'api/location', //获取省市县
        'method': 'GET'
    },
    'uploadFile': {
        'url': 'api/image/upload', //上传文件 
        'method': 'POST'
    },
    'sendAdminMsg': {
        'url': 'api/im/sendMsg', //发送管理员消息
        'method': 'POST'
    },
    'getHistoryMsg': {
        'url': 'api/user/getRoamMsg', //获取IM历史消息
        'method': 'POST'
    },
    'copyTreeList': {
        'url': 'api/user/family/application', //复制家谱申请列表
        'method': 'GET'
    },
    'removeApply': {
        'url': 'api/user/remove/application', //删除同意复制家谱申请
        'method': 'POST'
    },
    'handleCopyApply': {
        'url': 'api/user/handle/family/application', //处理复制家谱申请
        'method': 'POST'
    },
    'copyTree': {
        'url': 'api/user/copy/family', //复制家谱操作
        'method': 'POST'
    },
    'quantitySendMsg': {
        'url': 'api/user/batch/sendmsg', //批量发消息
        'method': 'POST'
    },
    'sendAdminMsg': {
        'url': 'api/im/sendMsg', //发送管理员消息
        'method': 'POST'
    },
    'versionFamily': {
        'url': 'api/user/version/family', //家谱历史
        'method': 'POST'
    },
    'tencentIm': {
        'url': "api/im/wechat", //腾讯IM api[token,api,data]
        'method': "POST"
    },
}